import { ReactElement } from 'react';
import { GuideContainer, ListContainer, Table } from './styles';
import {
  getMonthsGuideValues, getUnitsList, renderHeaders, renderRow,
} from './helpers';

interface PreFillGuideProps {
  units: { name: string, id: number }[];
}

export function PreFillGuide({
  units,
}: Readonly<PreFillGuideProps>): ReactElement {
  const sortedUnits = [...units].sort((a, b) => a.name.localeCompare(b.name));

  const monthValues = getMonthsGuideValues();
  const unitsValues = getUnitsList(sortedUnits);

  const staticData = {
    headers: ['', 'Unidade', 'ID da Unidade', 'Ano'],
    required: ['Sim', 'Sim', 'Sim'],
    restrictions: [
      'Deve ser um dos valores tabelados',
      'Deve ser um dos valores tabelados',
      'Os dados podem ser de anos vigentes, passados ou futuros e deverá ser apenas um valor',
    ],
    values: [
      <ListContainer key="units-names">{unitsValues.unitNames}</ListContainer>,
      <ListContainer key="units-ids">{unitsValues.ids}</ListContainer>,
      '',
    ],
    examples: [
      sortedUnits[0]?.name ?? 'Unidade',
      sortedUnits[0]?.id ?? '1',
      '2025',
    ],
  };

  return (
    <GuideContainer>
      <Table>
        {renderHeaders(staticData.headers, monthValues.headers)}
        <tbody>
          {renderRow('Obrigatório', staticData.required, monthValues.required)}
          {renderRow('Restrições', staticData.restrictions, monthValues.restrictions)}
          {renderRow('Valores tabelados', staticData.values, monthValues.values)}
          {renderRow('Exemplo', staticData.examples, monthValues.examples)}
        </tbody>
      </Table>
    </GuideContainer>
  );
}
